module.exports = __webpack_public_path__ + "img/plan-s2.d20e4bfb.svg";